/**
 * @generated SignedSource<<97beb7d77741ad23c286980517d63f1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AboHeader_header$data = {
  readonly tableheader: ReadonlyArray<{
    readonly col: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "AboHeader_header";
};
export type AboHeader_header$key = {
  readonly " $data"?: AboHeader_header$data;
  readonly " $fragmentSpreads": FragmentRefs<"AboHeader_header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AboHeader_header",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TableHeader",
      "kind": "LinkedField",
      "name": "tableheader",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "col",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SubscriptionTable",
  "abstractKey": null
};

(node as any).hash = "f97f84aee8f0153346b003889258f79d";

export default node;
